export default __webpack_public_path__ + "static/media/java.0153f184.svg";